import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const {
    public: { SENTRY_DSN, SENTRY_ENV },
  } = useRuntimeConfig()

  if (!SENTRY_DSN || !SENTRY_ENV) {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
    // integrations: [
    //   new Sentry.BrowserTracing({
    //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //   }),
    //   new Sentry.Replay(),
    // ],

    // Performance Monitoring
    tracesSampleRate: 0.01, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.01, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
})
